import * as React from "react";
//FB  6905 - Removed unused code
import Paper from "@mui/material/Paper";
//FB  6905 - Removed unused code
import NavBar from "../../../../components/Navbar";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
//FB  6905 Start - Imported style , Material UI components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./print.css";
import { GetAdminSettingValue } from "../../../../api";//FB  8817
//FB 7106
import {
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  ThemeProvider,
  Tooltip,
} from "@mui/material"; //FB 8396
import {
  PatientData,
  InvoiceData,
  AdminInvoiceData,
  AdminSetting,
  InsertPPLogs,
  GetLogo,
  InvoiceNumber,
  PostInvoiceNumber,
  GetPortalEmployeeN
} from "../../../../api"; //FB 8396  //FB  8817
import { DetialsProps, InvoiceModal } from "../../../../store";//FB  8817
//FB 8396
import { LoadingButton } from "@mui/lab";
import PrintIcon from '@mui/icons-material/Print';
import { useEffect, useState } from "react";
//FB  6905 End

// Update log
//FB  6192   02/06/2023  DK  Page to display billing summary
//FB  6905   05/31/2023  SK  PP Changes on Billing invoice screen
//FB  7096   07/17/2023  SK  PP - incorrect date on invoice
//FB  7106   07/28/2023  SK  Patient Portal : Billing screen enhancements
//FB  8117   02/23/2024  DK  Avoid calling EMR API directly from Portal
//FB  8403   03/12/2024  KI  PP- In payments screen state is not reflected
//FB  8396   03/13/2024  DK  Show statements on billing screen
//FB  8685   05/16/2024  SK   Pay button on portal needs to be greyed out if no callipay
//FB  8817   06/14/2024  SK  Logo and Invoice Number missing from invoice on portal
//FB  8818   06/16/2024  KI  request of message update on billing window
//FB  8816   07/01/2024  SK  Portal print invoice is glitching when exiting too early
//FB  8976   07/08/2024  MS  Fixed Invoice Number issue
//FB  9173   07/26/2024  GS  Invoice needs to be rounded up
//FB  9045   07/24/2024  MS  Added NPI
//FB  9087   07/24/2024  MS  Fixed billing address

//FB 6905 Omited style which are not a part in recent changes
export default function Billing() {
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  //FB 6905 - Start
  const theme = useTheme();
  //const [demo, setdemo] = React.useState(""); FB 9045
  const [check, setChecked] = React.useState(false);
  const [test, setTest] = React.useState(true);
  const [LicenseeName, setLicenseeName] = React.useState("");
  const [callipayID, setCallipayID] = React.useState(false);//FB 8685  //FB 8816
  const [billButton, setBillButton] = React.useState(true);//FB 7106
  const [Practice_Address, setPractice_Address] = React.useState("");
  const [Practice_City, setPractice_City] = React.useState("");
  const [Practice_State, setPractice_State] = React.useState("");
  const [Practice_Zip, setPractice_Zip] = React.useState("");
  const [total, setTotal] = React.useState<number>(0);
  const [open, setOpen] = React.useState(false);
  const [showSpinner, setShowSpinner] = React.useState(false);
  //FB 8396 - Start
  const [showStatementDialog, setShowStatementDialog] = React.useState(false);
  const [showStatements, setShowStatements] = React.useState(false);
  const [viewLoaderArray, setViewLoaderArray] = React.useState<Array<string>>([]);
  const [printLoaderArray, setPrintLoaderArray] = React.useState<Array<string>>([]);
  let userName: any;
  var invoiceMessage: any = ""; //FB 9045
  let data = sessionStorage.getItem("user");
  if (data != null) {
    userName = JSON.parse(data).Login;
  }
  //FB 8396 - End
  const [PatientDetails, setPatientDetails] = React.useState(
    {} as DetialsProps
  );
  const [InvioceDetails, setInvioceDetails] = React.useState<
    Array<InvoiceProps>
  >([]);
  //FB 9045 BEGIN
  type InvoiceProps = {
    bill_id: any;
    CLAIM_DATE: Date;
    CPTCODE_LABEL: any;
    CPTCODE_DESCRIPTION: any;
    line_item_amount: any;
    allowed_amount: any;
    discount: any;
    insurance_payment: any;
    patient_payment: any;
    copay_payment: any;
    coinsurance_payment: any;
    deductible_payment: any;
    patient_responsible: any;
    icds: any;
    EMPLOYEE_NAME: any;
    EMPLOYEE_PROVIDER_CODE: any;
	FACILITY_NPI: any;
	FACILITY_NAME: any;
	FACILITY_ADDRESS: any;
	FACILITY_ADDRESS2: any;
	FACILITY_CITY_STATE_ZIP: any;
	FACILITY_PHONE: any;
  };
  const [InvoiceAdminData, setInvoiceAdminData] = React.useState<InvoiceAdminProps>();
  type InvoiceAdminProps = {
    InvoiceMessage: any; 
		LicenseeName: any; 
		Practice_Address: any; 
		Practice_City: any; 
		Practice_State: any; 
		Practice_Zip: any; 
		Practice_Phone: any;
		IncludeNPIonInvoice: any; 
		Practice_PayTo_NPI: any; 
  };
  //FB 9045 END
  const handleClose = () => {
    setOpen(false);
  };
  let GetTotalBalance: number = 0;
  async function getTotal() {
    InvioceDetails.map(
      (x: any) =>
      (GetTotalBalance =
        GetTotalBalance + x.patient_responsible - x.patient_payment)
    );
    if (GetTotalBalance > 0) {
      setChecked(true);
      setTest(false);
    }
    setShowSpinner(false);
    //FB 7106 - Begin
    const GetTotalBalanceAsString = GetTotalBalance.toFixed(2).toString();
    sessionStorage.setItem("Total", GetTotalBalanceAsString);
    //FB 7106 - End
    setTotal(GetTotalBalance);
  }

  setTimeout(function () {
    getTotal();
  }, 5000);

  //FB 7106 - Begin
  const [selected, setSelected] = React.useState<Bill[]>([]); //FB 8403
  const [addedNumbers, setAddedNumbers] = React.useState(0);
  const [footerMessage, setFooterMessage] = useState(""); //FB 8818
  let sum: number = 0;
  //FB 8403 start
  interface Bill {
    billID: string;
    amount: number;
  }

  const handleClick = (event: React.ChangeEvent<HTMLInputElement>, billID: string, amount: number) => {
    const isChecked = event.target.checked;
    let newSelected: Bill[] = [...selected];

    function calculateSum(selectedItems: Bill[]) {
      let total = 0;
      for (const item of selectedItems) {
        total += item.amount;
      }
      return total;
    }

    if (isChecked) {
      newSelected.push({ billID, amount });
    } else {
      // Remove the item with matching billID
      newSelected = newSelected.filter(item => item.billID !== billID);
    }

    const sum = Number(calculateSum(newSelected));

    setAddedNumbers(sum);
    sessionStorage.setItem("PayingAmount", sum.toString());
    //FB 8685
    //FB 8816
    if (callipayID) {
      setBillButton(!(sum > 0)); // Set billButton based on sum
    }
    setSelected(newSelected);
  };
  //FB 8403 end
  //FB 7106 - End

  async function getDetails() {
    var dataEMR = sessionStorage.getItem("user");
    if (dataEMR != null) {
      const user = JSON.parse(dataEMR);
      if (user.Patient_n != null) {
        var data = await PatientData(user.EMRID);
        //FB 8117
        setPatientDetails({
          ...PatientDetails,
          Patient_ID: data.patient_ID,
          PATIENT_NAME: data.patienT_NAME,
          PATIENT_ADDRESS: data.patienT_ADDRESS,
          PATIENT_CITY_STATE_ZIP: data.patienT_CITY_STATE_ZIP,
        });
      }
    }
  }
  // FB 7096
  const date = new Date();
  async function getInvoiceDetails() {
    setShowSpinner(true);
    var dataEMR = sessionStorage.getItem("user");
    if (dataEMR != null) {
      const user = JSON.parse(dataEMR);
      if (user.Patient_n != null) {
        var data = await InvoiceData(user.EMRID);
        setInvioceDetails(data);
      }
    }
  }

  //let example: any;
  //FB 9045
  async function getAdminInvoiceDetails() {
    var example = await AdminInvoiceData();
    setInvoiceAdminData(example);
  }

  async function adminLicenseeName() {
    var data = await AdminSetting("LicenseeName");
    setLicenseeName(data);
    //FB 8685 - Begin
    const callipayData = await AdminSetting("CALLIPAY_API_KEY");
    //FB 8816 - Begin   CLON-2
    const settingValue = callipayData?.[0];
    setCallipayID(!!settingValue?.trim());
    //if (callipayData.length > 0) {
    //  setCallipayID(true);
    //}
    //FB 8816 - End
    //FB 8685 - End
  }
  async function adminPractice_Address() {
    var data = await AdminSetting("Practice_Address");
    setPractice_Address(data);
  }
  async function adminPractice_City() {
    var data = await AdminSetting("Practice_City");
    setPractice_City(data);
  }
  async function adminPractice_State() {
    var data = await AdminSetting("Practice_State");
    setPractice_State(data);
  }
  async function adminPractice_Zip() {
    var data = await AdminSetting("Practice_Zip");
    setPractice_Zip(data);
  }
  //FB  8817  - Begin
  const [invoiceStruc, setInvoiceStruc] = useState({} as InvoiceModal);
  const [isDisabled, setIsDisabled] = useState(false);//FB 8816
  const [closeDisabled, setCloseDisabled] = useState(false);//FB 8816
  async function handlePrint() {
    //FB 8976 BEGIN
    //var dataEMR = sessionStorage.getItem("PatientInfo");
    var dataEMR = sessionStorage.getItem("user");
    if (dataEMR != null) {
      const user = JSON.parse(dataEMR);
      let id = await InvoiceNumber(Number(user.EMRID));
      //let id = await InvoiceNumber();
      //let adminData = await AdminSetting("Start_Invoice_Number");
      //const Invoice = id + Number(adminData) + 1;
      setInvoiceID(id);
      const formattedDate = getFormattedDate();
      const dateObject = new Date(formattedDate);
      let data = await GetPortalEmployeeN();
      var dataEMR = sessionStorage.getItem("user");
      if (dataEMR != null) {
        const user = JSON.parse(dataEMR);
        if (user.Patient_n != null) {
          const updatedInvoiceStruc = {
            ...invoiceStruc,
            INVOICE_PRINT_LOG_N: id,
            PRINT_DATE: dateObject,
            PATIENT_N: user.EMRID,
            EMPLOYEE_N: Number(data),
            INVOICE_NUMBER: id,
            AMOUNT: total
          };
          PostInvoiceNumber(updatedInvoiceStruc);
          //FB  8817 - End
        }
        setOpen(true);
        //FB 8396
        InsertPPLogs(
          "Clicked on Print Invoice - Billing Page",
          window.location.href,
          userName,
          ""
        );
        setIsDisabled(true);//FB 8816
        setTimeout(function () {
          window.print();
        }, 3000); //FB 8396
        //FB 8816 - Begin
        setTimeout(() => {
          setIsDisabled(false);
        }, 4000);
        //FB 8816 - End
      }
    }
    //FB 8976 END
  }
  //FB  8817- Begin
  function getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');

    return `${year}/${month}/${day}`;
  }

  const [logo, setLogo] = useState("");
  const [enableLogo, setEnableLogo] = useState(false);
  const [invoiceID, setInvoiceID] = useState(0);
  const [sqlData, setSQLdata] = useState("");
  async function GetLogoImage() {

    var img = await GetLogo();
    if (img != null && img != undefined) {
      setLogo(img);
    }
    var data = await AdminSetting("show_invoice_logo");
    if (data == 1) {
      setEnableLogo(true);
    }
  }
  //FB  8817 - End
  //FB 8818
  async function GetFooterMessage() {
    let message = await GetAdminSettingValue("PortalBillingText");
    setFooterMessage(message);
  }

  React.useEffect(() => {
    GetLogoImage();//FB 8817
    getDetails();
    getInvoiceDetails();
    getAdminInvoiceDetails();
    adminLicenseeName();
    adminPractice_Address();
    adminPractice_City();
    adminPractice_State();
    adminPractice_Zip();
    GetFooterMessage(); //FB 8818
  }, []);

  //FB 8396 - Start
  const handleViewInvoiceClick = () => {
    InsertPPLogs(
      "Clicked on View Invoice - Billing Page",
      window.location.href,
      userName,
      ""
    );
    setShowStatements(false);
  }
  const [statements, setStatements] = useState<Array<{ Date: Date, Balance: any }>>([]);
  const [statementTotal, setStatementTotal] = useState(0);
  const [filteredStatements, setFilteredStatements] = useState<InvoiceProps[]>([]);

  function FormatDate(date: any) {
    return new Date(date)
      .toLocaleDateString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(",", "");
  }

  function UpdateStatementTotal() {
    filteredStatements.map(
      (x: any) =>
      (GetTotalBalance =
        GetTotalBalance + x.patient_responsible - x.patient_payment)
    );
    const GetTotalBalanceAsString = GetTotalBalance.toFixed(2).toString();
    sessionStorage.setItem("StatementTotal", GetTotalBalanceAsString);
    setStatementTotal(GetTotalBalance);
  }

  function handleViewStatementClick() {
    InsertPPLogs(
      "Clicked on View Statements - Billing Page",
      window.location.href,
      userName,
      ""
    );
    let statementsByDate = Array.from(InvioceDetails.reduce((m, v) => m.set(v.CLAIM_DATE, [...m.get(v.CLAIM_DATE) || [], v]), new Map).values());

    let consolidatedStatements = statementsByDate.map((smt: InvoiceProps[]) => {
      let patient_responsible = smt.reduce(function (prev, current) {
        return prev + +current.patient_responsible;
      }, 0);

      let patient_payment = smt.reduce(function (prev, current) {
        return prev + +current.patient_payment;
      }, 0);

      return { "Date": smt[0].CLAIM_DATE, "Balance": (patient_responsible - patient_payment).toFixed(2) }
    });

    setStatements(consolidatedStatements);
    setShowStatements(true);
  }

  function ViewStatement(statement: any) {
    InsertPPLogs(
      "Clicked on View Statement - Billing Page",
      window.location.href,
      userName,
      ""
    );
    setViewLoaderArray([...viewLoaderArray, FormatDate(statement.Date)]);
    setFilteredStatements(InvioceDetails.filter((st) => FormatDate(st.CLAIM_DATE) == FormatDate(statement.Date)));
    setShowStatementDialog(true);
  }

  function PrintStatement(statement: any) {
    InsertPPLogs(
      "Clicked on Print Statement - Billing Page",
      window.location.href,
      userName,
      ""
    );
    setPrintLoaderArray([...printLoaderArray, FormatDate(statement.Date)]);
    setFilteredStatements(InvioceDetails.filter((st) => FormatDate(st.CLAIM_DATE) == FormatDate(statement.Date)));
    setShowStatementDialog(true);
    setCloseDisabled(true);//FB 8816
    setTimeout(function () {
      window.print();
    }, 3000);
    //FB 8816 - Begin
    setTimeout(() => {
      setCloseDisabled(false);
    }, 4000);
    //FB 8816 - End	
  }

  function CloseStatementDialog() {
    setShowStatementDialog(false);
    setViewLoaderArray([]);
    setPrintLoaderArray([]);
  }

  useEffect(() => {
    UpdateStatementTotal();
  }, [filteredStatements]);
  //FB 8396 - End

  //FB 6905 - End
  return (
    <div>
      {matches && <NavBar />}
      {!matches && (
        <div
          className="row"
          style={{
            paddingLeft: "25px",
            paddingTop: "16px",
            backgroundColor: "#F5F5F5",
            fontWeight: "bold",
          }}
        >
          Billing{" "}
          <hr
            style={{ height: "2px", border: "none", backgroundColor: "black" }}
          ></hr>
        </div>
      )}
      {/* FB 6905 - Replacing Hard-Coded Data with Dynamic Data - Start */}
      <div
        style={
          matches == false ? stylestopmobile.container : stylestart.container
        }
      >
        {/* FB 8396 */}
        {/* FB 8685 */}
        {!billButton && (
          <button
            className="btn"
            style={Pay.container}
            //FB 7106
            disabled={billButton}
            onClick={() => {
              navigate("/user/home/MakePayment");
              InsertPPLogs(
                "Clicked on pay bill - Billing Page",
                window.location.href,
                userName,
                ""
              );
            }}
          >
            {/* FB 7106 */}
            Pay Bill
          </button>
        )}
        &nbsp;
        {!test && (
          <button className="btn" style={Pay.container} onClick={handlePrint}>
            {/* FB 7106 */}
            Print Invoice
          </button>
        )}
        {/* FB 8396 - Start*/}
        &nbsp;
        {!test && showStatements && (
          <button className="btn" style={Pay.container} onClick={handleViewInvoiceClick}>
            View Invoice(s)
          </button>
        )}
        &nbsp;
        {!test && !showStatements && (
          <button className="btn" style={Pay.container} onClick={handleViewStatementClick}>
            View Statement(s)
          </button>
        )}
        {/* FB 8396 - End*/}
        <br />
        {test && (
          <div
            style={{
              height: "100%",
              backgroundColor: "#F5F5F5",
              paddingTop: "20px",
            }}
          >
            {" "}
            No Due Payment
          </div>
        )}
        {check && (
          <div>
            {/* FB 8818 - Start*/}
            <div className="mt-3 text-center font-weight-bold text-sm">
              <strong>{footerMessage}</strong>
            </div>
            <div className="row">
              <TableContainer component={Paper} style={{ marginTop: "20px", marginBottom: "20px" }}>
                {/* FB 8396 - Start*/}
                {showStatements ?
                  (
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">
                            <strong>Service Date</strong>
                          </TableCell>
                          <TableCell align="center">
                            <strong>Remaining Patient Balance</strong>&nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Tools</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {statements.map((smt) => (
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell align="center">
                              <LoadingButton
                                loading={viewLoaderArray.indexOf(FormatDate(smt.Date)) > -1}
                                loadingPosition="center"
                                loadingIndicator={
                                  <CircularProgress
                                    size={20}
                                    style={{ color: "#083A4D" }}
                                  />
                                }
                                onClick={() => ViewStatement(smt)}
                                style={{ color: "#083A4D" }}
                              >
                                <b>{FormatDate(smt.Date)}</b>
                              </LoadingButton>
                            </TableCell>
                            <TableCell align="center">
                              ${smt.Balance}
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip title="Print Statement" placement="top-start">
                                <LoadingButton
                                  loading={viewLoaderArray.indexOf(FormatDate(smt.Date)) > -1}
                                  loadingPosition="center"
                                  loadingIndicator={
                                    <CircularProgress
                                      size={20}
                                      style={{ color: "#083A4D" }}
                                    />
                                  }
                                  onClick={() => PrintStatement(smt)}
                                  startIcon={
                                    <PrintIcon style={{
                                      color: viewLoaderArray.indexOf(FormatDate(smt.Date)) > -1 ? "white" : "#083A4D"
                                    }} />
                                  }
                                />
                              </Tooltip>
                            </TableCell>
                          </TableRow>))}
                      </TableBody>
                    </Table>
                  ) : (
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <caption style={{ textAlign: "right", color: "black" }}>
                        <strong>Total Balance: $ {total.toFixed(2)} </strong><br /> {/* FB 7106 */}
                        <strong style={{ color: "black" }}>Paying Amount: $ {addedNumbers.toFixed(2)} </strong>{/* FB 7106 */}
                      </caption>
                      <TableHead>
                        <TableRow>
                          {/* FB 7106 - Begin */}
                          {/* FB 8816 - Begin */}
                          {callipayID && (
                            <TableCell align="center">
                              <strong>Pay This</strong>
                            </TableCell>
                          )}
                          {/* FB 8816 - End */}
                          {/* FB 7106 - End */}
                          <TableCell align="center">
                            <strong>Service Date</strong>
                          </TableCell>
                          <TableCell align="center">
                            <strong>Procedure Code/ Description</strong>&nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Diagnosis Code(s)</strong> &nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Our Charge</strong>&nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Allowed Amount</strong>&nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Discount</strong>&nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Insurance Payments</strong>&nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Patient Responsible</strong>&nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Patient Payment</strong>&nbsp;
                          </TableCell>
                          <TableCell align="center">
                            <strong>Remaining Patient Balance</strong>&nbsp;
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {InvioceDetails.map((x) => (
                          <TableRow
                            key={x.bill_id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            {/* FB 7106 - Begin */}
                            {/* FB 8166 */}
                            {callipayID && (
                              <TableCell style={showStatements ? { display: 'none' } : {}}>
                                <Checkbox
                                  color="primary"
                                  onClick={(event: any) => handleClick(event, x.bill_id, parseFloat((x.patient_responsible - x.patient_payment).toFixed(2)))}
                                />
                              </TableCell>
                            )}
                            {/* FB 7106 - End */}
                            <TableCell align="center">
                              {FormatDate(x.CLAIM_DATE)}
                            </TableCell>
                            <TableCell align="center">
                              {x.CPTCODE_LABEL + " " + x.CPTCODE_DESCRIPTION}
                            </TableCell>
                            <TableCell align="center">{x.icds}</TableCell>
                            <TableCell align="center">
                              ${x.line_item_amount.toFixed(2)}
                            </TableCell>
                            <TableCell align="center">
                              ${x.allowed_amount.toFixed(2)}
                            </TableCell>
                            <TableCell align="center">
                              (${x.discount.toFixed(2)})
                            </TableCell>
                            <TableCell align="center">
                              (${x.insurance_payment.toFixed(2)})
                            </TableCell>
                            <TableCell align="center">
                              ${x.patient_responsible.toFixed(2)}
                            </TableCell>
                            <TableCell align="center">
                              ${x.patient_payment.toFixed(2)}
                            </TableCell>
                            <TableCell align="center">
                              ${(x.patient_responsible - x.patient_payment).toFixed(2)}
                            </TableCell>
                          </TableRow>))}
                      </TableBody>
                    </Table>
                  )}
                {/* FB 8396 - End*/}
              </TableContainer>
              {/* FB 8818 adding the text on top
				<div className="mt-3 text-center font-weight-bold text-secondary text-sm">
				  Reminder: You are responsible for payment regardless of insurance
				  coverage. If payment has been made, please disregard this notice.
				</div>
			  */}
            </div>
          </div>
        )}
      </div>

      <ThemeProvider theme={theme}>
        <Dialog open={showSpinner} fullWidth maxWidth={"xs"}>
          <DialogContent
            style={{
              display: "flex",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress style={{ color: "#083A4D" }} />
          </DialogContent>
        </Dialog>
      </ThemeProvider>

      <Dialog
        open={open}
        onClose={handleClose}
        style={{ width: "95%" }}
        fullScreen
      >
        {open && (
          <div className="container-fluid py-4 px-3 printmargin">
            <div className="HideIcon">
              {/* FB  8816 */}
              <IconButton onClick={handleClose} aria-label="close" disabled={isDisabled}>
                <CloseIcon />
              </IconButton>
            </div>

            <div className="row">
              {/* FB  8817 - Begin */}
              <div>
                {enableLogo && (
                  <img
                    src={logo}
                    alt="logo"
                    style={
                      matches == false
                        ? { width: '93px', height: '40px', cursor: 'pointer' }
                        : { maxWidth: '75vw', cursor: 'pointer' }
                    }
                  />)}
              </div>
              {/* FB  8817 - End */}
              <div className="col-5">
                <div className="font-weight-bold FontSize">{LicenseeName}</div>
                <div>{Practice_Address} </div>
                <div>
                  {Practice_City}&nbsp;{Practice_State}&nbsp;{Practice_Zip}
                </div>
                {/* FB 9045 BEGIN */}
                <div>
                  {InvoiceAdminData && InvoiceAdminData.IncludeNPIonInvoice == 1 && InvioceDetails.length > 0
                  ?
                    "NPI: " + InvioceDetails[0].EMPLOYEE_PROVIDER_CODE 
                  :   
                  InvoiceAdminData && InvoiceAdminData.IncludeNPIonInvoice == 2 && InvioceDetails.length > 0
                  ?
                    "NPI: " + InvioceDetails[0].FACILITY_NPI
                  :
                  InvoiceAdminData && InvoiceAdminData.IncludeNPIonInvoice == 3
                  ?
                    "NPI: " + InvoiceAdminData.Practice_PayTo_NPI : ""}
                </div>
                {/* FB 9045 END */}
                <div className="font-weight-bold">RETURN SERVICE REQUESTED</div>
              </div>

              <div className="col-6">
                <div className="border border-dark row">
                  <div className="w-100 border-bottom border-dark text-center py-3">{/* FB  8817  */}
                    Patient ID: {PatientDetails.Patient_ID} &nbsp; &nbsp; Invoice Number :{invoiceID}
                  </div>
                  <div
                    className="border-bottom border-right border-dark text-center py-2"
                    style={{ width: " 40%" }}
                  >
                    <div className="font-weight-bold">STATEMENT DATE</div>
                    {/* FB 7096 - Replaced Hardcoded Date with dynamic date -  Begin */}
                    {/* FB 8396*/}
                    <div>
                      {FormatDate(date)}
                    </div>
                    {/* FB 7096 - End */}
                  </div>
                  <div
                    className="border-bottom border-right border-dark text-center py-2"
                    style={{ width: " 40%" }}
                  >
                    <div className="font-weight-bold">ACCOUNT NUMBER</div>
                    <div>{PatientDetails.Patient_ID}</div>
                  </div>
                  <div
                    className="border-bottom border-dark text-center px-3 py-2"
                    style={{ width: " 20%" }}
                  >
                    <div className="font-weight-bold">TOTAL DUE</div>
                    {/* FB 9173 */}
                    <div>$ {total.toFixed(2)} </div>
                  </div>
                  <div className="w-50 border-right border-dark px-3 py-2">
                    <div className="font-weight-bold">PAYMENT DUE BY</div>
                    <div>UPON RECEIPT</div>
                  </div>
                  <div className="w-50  border-dark px-3 py-2">
                    <div className="font-weight-bold">AMOUNT ENCLOSED</div>
                    <div>$</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex mt-4">
              <div className="col-5">
                <div className="font-weight-bold">ADDRESSEE:</div>
                <div className="ml-4">{PatientDetails.PATIENT_NAME} </div>
                <div className="ml-4">{PatientDetails.PATIENT_ADDRESS} </div>
                <div className="ml-4">
                  {PatientDetails.PATIENT_CITY_STATE_ZIP}{" "}
                </div>
              </div>
              {/* FB 9087 BEGIN */}
              <div className="col-7">
                <div>
                  <div dangerouslySetInnerHTML={{ __html: 
                  InvoiceAdminData ?   
                      InvioceDetails.length > 0 
                      ?
                      invoiceMessage = InvoiceAdminData.InvoiceMessage.replace("100px", "0px")
                        .replace("@facility_name", InvioceDetails[0].FACILITY_NAME)
                        .replace("@facility_address", InvioceDetails[0].FACILITY_ADDRESS)
                        .replace("@facility_address2", InvioceDetails[0].FACILITY_ADDRESS2)
                        .replace("@facility_city_state_zip", InvioceDetails[0].FACILITY_CITY_STATE_ZIP)
                        .replace("@facility_phone", InvioceDetails[0].FACILITY_PHONE)
                      :
                      InvoiceAdminData.InvoiceMessage.replace("@facility_name", InvoiceAdminData ? InvoiceAdminData.LicenseeName : "")
                        .replace("@facility_address", InvoiceAdminData ? InvoiceAdminData.Practice_Address: "")
                        .replace("@facility_address2", "")
                        .replace("@facility_city_state_zip", InvoiceAdminData ? InvoiceAdminData.Practice_City + ", " + InvoiceAdminData && InvoiceAdminData.Practice_State + " " + InvoiceAdminData && InvoiceAdminData.Practice_Zip : "")
                        .replace("@facility_phone", InvoiceAdminData ? InvoiceAdminData.Practice_Phone : "") : ""
                    }} />
                </div>
              </div>
              {/* FB 9087 END */}
            </div>

            <div className="mt-5">
              <div className="text-right">
                PLEASE DETACH AND RETURN TOP PORTION WITH YOUR PAYMENT
              </div>

              <div className="row mt-3">
                <div className="col-3">
                  <div className="font-weight-bold">Patient:</div>
                  <div className="font-weight-bold">Rendering Provider:</div>
                  <div className="font-weight-bold">Location</div>
                </div>
                <div className="col-3">
                  <div>{PatientDetails.PATIENT_NAME} </div>
                  <div></div>
                  <div></div>
                </div>
                <div className="col-3">
                  <div className="font-weight-bold">Patient Number:</div>
                  <div className="font-weight-bold">Due Date:</div>
                  <div className="font-weight-bold">Patient Balance:</div>
                </div>
                <div className="col-3">
                  <div>{PatientDetails.Patient_ID} </div>
                  <div>Upon Receipt</div>
                  {/* FB 9173 */}
                  <div>$ {total.toFixed(2)} </div> 
                </div>
              </div>

              <table className="mt-2 ">
                <thead>
                  <tr>
                    <th className="pt-4 px-3">Service Date</th>
                    <th className="pt-4 px-3">Procedure Code/ Description</th>
                    <th className="pt-4 px-3">Diagnosis Code(s)</th>
                    <th className="pt-4 px-3">Our Charge</th>
                    <th className="pt-4 px-3">Allowed Amount</th>
                    <th className="pt-4 px-3">Discount</th>
                    <th className="pt-4 px-3">Insurance Payments</th>
                    <th className="pt-4 px-3">Patient Responsible</th>
                    <th className="pt-4 px-3">Patient Payment</th>
                    <th>Remaining Patient Balance</th>
                  </tr>
                </thead>

                <tbody>
                  {InvioceDetails.map((x) => (
                    <tr>
                      {/* FB 8396*/}
                      <td className="pt-4 px-3">
                        {FormatDate(x.CLAIM_DATE)}{" "}
                      </td>
                      <td className="pt-4 px-3">
                        {x.CPTCODE_LABEL}
                        {""}
                        {x.CPTCODE_DESCRIPTION}
                      </td>
                      <td className="pt-4 px-3">{x.icds} </td>
                      <td className="pt-4 px-3 text-right">
                        ${x.line_item_amount.toFixed(2)}
                      </td>
                      <td className="pt-4 px-3 text-right">
                        ${x.allowed_amount.toFixed(2)}
                      </td>
                      <td className="pt-4 px-3 text-right">
                        (${x.discount.toFixed(2)})
                      </td>
                      <td className="pt-4 px-3 text-right">
                        (${x.insurance_payment.toFixed(2)})
                      </td>
                      <td className="pt-4 px-3 text-right">
                        ${x.patient_responsible.toFixed(2)}
                      </td>
                      <td className="pt-4 px-3 text-right">
                        ${x.patient_payment.toFixed(2)}
                      </td>
                      <td>
                        $
                        {(x.patient_responsible - x.patient_payment).toFixed(2)}
                      </td>
                    </tr>
                  ))}

                  <tr>
                    <td
                      colSpan={10}
                      align="right"
                      className="py-4 px-4 font-weight-bold text-right"
                    >
                      <b> Total Balance :$ {total.toFixed(2)} </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-3 text-center font-weight-bold text-secondary text-sm">
              Reminder: You are responsible for payment regardless of insurance
              coverage. If payment has been made, please disregard this notice.
            </div>
          </div>
        )}
      </Dialog>
      {/* FB 6905 - End */}

      {/* FB 8396 - Start*/}
      <Dialog
        open={showStatementDialog}
        onClose={CloseStatementDialog}
        style={{ width: "95%" }}
        fullScreen
      >
        {showStatementDialog && (
          <div className="container-fluid py-4 px-3 printmargin">
            <div className="HideIcon">
              {/* FB 8816 */}
              <IconButton onClick={CloseStatementDialog} aria-label="close" disabled={closeDisabled}>
                <CloseIcon />
              </IconButton>
            </div>

            <div className="row">
              {/* FB  8817 - Begin */}
              <div>
                {enableLogo && (
                  <img
                    src={logo}
                    alt="logo"
                    style={
                      matches == false
                        ? { width: '93px', height: '40px', cursor: 'pointer' }
                        : { maxWidth: '75vw', cursor: 'pointer' }
                    }
                  />)}
              </div>
              {/* FB  8817 - End */}
              <div className="col-5">
                <div className="font-weight-bold FontSize">{LicenseeName}</div>
                <div>{Practice_Address} </div>
                <div>
                  {Practice_City}&nbsp;{Practice_State}&nbsp;{Practice_Zip}
                </div>
                {/* FB 9045 BEGIN */}
                <div>
                  {InvoiceAdminData && InvoiceAdminData.IncludeNPIonInvoice == 1 && InvioceDetails.length > 0
                  ?
                    "NPI: " + InvioceDetails[0].EMPLOYEE_PROVIDER_CODE 
                  :   
                  InvoiceAdminData && InvoiceAdminData.IncludeNPIonInvoice == 2 && InvioceDetails.length > 0
                  ?
                    "NPI: " + InvioceDetails[0].FACILITY_NPI
                  :
                  InvoiceAdminData && InvoiceAdminData.IncludeNPIonInvoice == 3
                  ?
                    "NPI: " + InvoiceAdminData.Practice_PayTo_NPI : ""}
                </div>
                {/* FB 9045 END */}
                <div className="font-weight-bold">RETURN SERVICE REQUESTED</div>
              </div>

              <div className="col-6">
                <div className="border border-dark row">
                  <div className="w-100 border-bottom border-dark text-center py-3">
                    Patient ID: {PatientDetails.Patient_ID}
                  </div>
                  <div
                    className="border-bottom border-right border-dark text-center py-2"
                    style={{ width: " 40%" }}
                  >
                    <div className="font-weight-bold">STATEMENT DATE</div>
                    <div>
                      {FormatDate(date)}
                    </div>
                  </div>
                  <div
                    className="border-bottom border-right border-dark text-center py-2"
                    style={{ width: " 40%" }}
                  >
                    <div className="font-weight-bold">ACCOUNT NUMBER</div>
                    <div>{PatientDetails.Patient_ID}</div>
                  </div>
                  <div
                    className="border-bottom border-dark text-center px-3 py-2"
                    style={{ width: " 20%" }}
                  >
                    <div className="font-weight-bold">TOTAL DUE</div>
                    {/* FB 9173 */}
                    <div>$ {statementTotal.toFixed(2)} </div>
                  </div>
                  <div className="w-50 border-right border-dark px-3 py-2">
                    <div className="font-weight-bold">PAYMENT DUE BY</div>
                    <div>UPON RECEIPT</div>
                  </div>
                  <div className="w-50  border-dark px-3 py-2">
                    <div className="font-weight-bold">AMOUNT ENCLOSED</div>
                    <div>$</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex mt-4">
              <div className="col-5">
                <div className="font-weight-bold">ADDRESSEE:</div>
                <div className="ml-4">{PatientDetails.PATIENT_NAME} </div>
                <div className="ml-4">{PatientDetails.PATIENT_ADDRESS} </div>
                <div className="ml-4">
                  {PatientDetails.PATIENT_CITY_STATE_ZIP}{" "}
                </div>
              </div>
              {/* FB 9087 BEGIN */}
              <div className="col-7">
                <div>
                  <div dangerouslySetInnerHTML={{ __html: 
                  InvoiceAdminData ?   
                      InvioceDetails.length > 0 
                      ?
                      invoiceMessage = InvoiceAdminData.InvoiceMessage.replace("100px", "0px")
                        .replace("@facility_name", filteredStatements[filteredStatements.length - 1].FACILITY_NAME)
                        .replace("@facility_address", filteredStatements[filteredStatements.length - 1].FACILITY_ADDRESS)
                        .replace("@facility_address2", filteredStatements[filteredStatements.length - 1].FACILITY_ADDRESS2)
                        .replace("@facility_city_state_zip", filteredStatements[filteredStatements.length - 1].FACILITY_CITY_STATE_ZIP)
                        .replace("@facility_phone", filteredStatements[filteredStatements.length - 1].FACILITY_PHONE)
                      :
                      InvoiceAdminData.InvoiceMessage.replace("@facility_name", InvoiceAdminData ? InvoiceAdminData.LicenseeName : "")
                        .replace("@facility_address", InvoiceAdminData ? InvoiceAdminData.Practice_Address: "")
                        .replace("@facility_address2", "")
                        .replace("@facility_city_state_zip", InvoiceAdminData ? InvoiceAdminData.Practice_City + ", " + InvoiceAdminData && InvoiceAdminData.Practice_State + " " + InvoiceAdminData && InvoiceAdminData.Practice_Zip : "")
                        .replace("@facility_phone", InvoiceAdminData ? InvoiceAdminData.Practice_Phone : "") : ""
                    }} />
                </div>
              </div>
              {/* FB 9087 END */}
            </div>

            <div className="mt-5">
              <div className="text-right">
                PLEASE DETACH AND RETURN TOP PORTION WITH YOUR PAYMENT
              </div>

              <div className="row mt-3">
                <div className="col-3">
                  <div className="font-weight-bold">Patient:</div>
                  <div className="font-weight-bold">Rendering Provider:</div>
                  <div className="font-weight-bold">Location</div>
                </div>
                <div className="col-3">
                  <div>{PatientDetails.PATIENT_NAME} </div>
                  <div></div>
                  <div></div>
                </div>
                <div className="col-3">
                  <div className="font-weight-bold">Patient Number:</div>
                  <div className="font-weight-bold">Due Date:</div>
                  <div className="font-weight-bold">Patient Balance:</div>
                </div>
                <div className="col-3">
                  <div>{PatientDetails.Patient_ID} </div>
                  <div>Upon Receipt</div>
                  <div>$ {statementTotal} </div>
                </div>
              </div>

              <table className="mt-2 ">
                <thead>
                  <tr>
                    <th className="pt-4 px-3">Service Date</th>
                    <th className="pt-4 px-3">Procedure Code/ Description</th>
                    <th className="pt-4 px-3">Diagnosis Code(s)</th>
                    <th className="pt-4 px-3">Our Charge</th>
                    <th className="pt-4 px-3">Allowed Amount</th>
                    <th className="pt-4 px-3">Discount</th>
                    <th className="pt-4 px-3">Insurance Payments</th>
                    <th className="pt-4 px-3">Patient Responsible</th>
                    <th className="pt-4 px-3">Patient Payment</th>
                    <th>Remaining Patient Balance</th>
                  </tr>
                </thead>

                <tbody>
                  {filteredStatements.map((x) => (
                    <tr>
                      <td className="pt-4 px-3">
                        {FormatDate(x.CLAIM_DATE)}{" "}
                      </td>
                      <td className="pt-4 px-3">
                        {x.CPTCODE_LABEL + " " + x.CPTCODE_DESCRIPTION}
                      </td>
                      <td className="pt-4 px-3">{x.icds} </td>
                      <td className="pt-4 px-3 text-right">
                        ${x.line_item_amount.toFixed(2)}
                      </td>
                      <td className="pt-4 px-3 text-right">
                        ${x.allowed_amount.toFixed(2)}
                      </td>
                      <td className="pt-4 px-3 text-right">
                        (${x.discount.toFixed(2)})
                      </td>
                      <td className="pt-4 px-3 text-right">
                        (${x.insurance_payment.toFixed(2)})
                      </td>
                      <td className="pt-4 px-3 text-right">
                        ${x.patient_responsible.toFixed(2)}
                      </td>
                      <td className="pt-4 px-3 text-right">
                        ${x.patient_payment.toFixed(2)}
                      </td>
                      <td>
                        $
                        {(x.patient_responsible - x.patient_payment).toFixed(2)}
                      </td>
                    </tr>
                  ))}

                  <tr>
                    <td
                      colSpan={10}
                      align="right"
                      className="py-4 px-4 font-weight-bold text-right"
                    >
                      <b> Total Balance :$ {statementTotal.toFixed(2)} </b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-3 text-center font-weight-bold text-secondary text-sm">
              Reminder: You are responsible for payment regardless of insurance
              coverage. If payment has been made, please disregard this notice.
            </div>
          </div>
        )}
      </Dialog>
      {/* FB 8396 - End*/}
    </div>
  );
}

const stylestart = {
  container: {
    border: "5px grey",
    paddingLeft: "80px",
    marginBottom: "20px",
    backgroundColor: "#F5F5F5",
    paddingTop: "20px",
    // FB 6905
    paddingRight: "80px",
  },
};
const stylestopmobile = {
  container: {
    padding: "0px 16px 32px 16px",
    backgroundColor: "#F5F5F5",
    // FB 6905 Delete Commented Lines
  },
};

const card = {
  container: {
    border: "5px white",
    minHeight: "150px",
  },
};
const Pay = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};

const View = {
  container: {
    color: "#13607C",
    backgroundColor: "#F5F5F7",
    marginRight: "165px",
    borderColor: "#13607C",
    fontWeight: 700,
  },
};
